//DefaultTable

import * as React from 'react';
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box';
import { DataGrid, gridClasses, GridToolbar } from '@mui/x-data-grid';
import { Button, Card, CardBody, CardTitle, CardFooter, Alert } from 'reactstrap';
import { alpha, styled } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import HouseboatIcon from '@mui/icons-material/Houseboat';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { FaPallet } from 'react-icons/fa';
import { FaBoxes } from 'react-icons/fa';
import { FaBox } from 'react-icons/fa';
import { ErrorModal } from '../General/ErrorModal'

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));



const keyField = 'paletizado_Id';

export default function PaletizadosVariantes_Table(props) {
    const [pageSize, setPageSize] = React.useState(10);
    const [rows, setRows] = React.useState(props.data);
    const [showError, setShowError] = React.useState(false);
    //const [sortModel, setSortModel] = React.useState([
    //    {
    //        field: keyField,
    //        sort: 'desc',
    //    },
    //]);
    const intl = useIntl();
    const navigate = useNavigate();
    // Sorting function based on custom sorting logic


    const pesosFaltantes = rows.filter(obj => obj.productNetWeight == 0 || obj.productNetWeight == null || obj.productTaraWeight == 0 || obj.productTaraWeight == null).length;


    const sortRows = (data) => {
        // Create a shallow copy of the data array to avoid mutation
        const dataCopy = [...data];

        return dataCopy.sort((a, b) => {
            // Sort by RetailVariantId being null or empty
            if (!a.retailVariantId && b.retailVariantId) return -1;
            if (a.retailVariantId && !b.retailVariantId) return 1;

            // Sort by ProductNetWeight being null or 0
            if ((!a.productNetWeight || a.productNetWeight === 0) && (b.productNetWeight && b.productNetWeight !== 0)) return -1;
            if ((a.productNetWeight && a.productNetWeight !== 0) && (!b.productNetWeight || b.productNetWeight === 0)) return 1;

            // Sort by ProductTaraWeight being null or 0
            if ((!a.productTaraWeight || a.productTaraWeight === 0) && (b.productTaraWeight && b.productTaraWeight !== 0)) return -1;
            if ((a.productTaraWeight && a.productTaraWeight !== 0) && (!b.productTaraWeight || b.productTaraWeight === 0)) return 1;

            // Then by EtiquetaCore (alphabetical)
            if (a.etiquetaCore < b.etiquetaCore) return -1;
            if (a.etiquetaCore > b.etiquetaCore) return 1;

            // Then by Calibre (number)
            if (a.calibre < b.calibre) return -1;
            if (a.calibre > b.calibre) return 1;

            // Then by CajasPorPaleta (number)
            if (a.cajasPorPaleta < b.cajasPorPaleta) return -1;
            if (a.cajasPorPaleta > b.cajasPorPaleta) return 1;

            return 0;
        });
    };

    // Use the sorted rows in your component
    const sortedRows = sortRows(rows);


    console.log(sortedRows);

    const columns = [
        {
            field: keyField,
            headerName: 'ID',
            width: 90,
            type: 'number',
            hide: true
        },
        {
            field: 'codigoTMU',
            headerName: intl.formatMessage({ id: 'CodigoTMU' }),
            editable: false,
            flex: 120,
        },
        {
            field: 'etiquetaCore',
            headerName: intl.formatMessage({ id: 'EtiquetaCore' }),
            editable: false,
            flex: 120,
        },
        {
            field: 'calibre',
            headerName: intl.formatMessage({ id: 'Calibre' }),
            editable: false,
            flex: 60,
        },
        {
            field: 'cajasPorPaleta',
            headerName: intl.formatMessage({ id: 'CajasPorPaleta' }),
            editable: false,
            flex: 60,
        },
        {
            field: 'retailVariantId',
            headerName: intl.formatMessage({ id: 'RetailVariantId' }),
            editable: false,
            flex: 60,
        },
        {
            field: 'productNetWeight',
            headerName: intl.formatMessage({ id: 'ProductNetWeight' }),
            editable: false,
            flex: 60,
        },
        {
            field: 'productTaraWeight',
            headerName: intl.formatMessage({ id: 'ProductTaraWeight' }),
            editable: false,
            flex: 60,
        },
        {
            field: 'estado',
            headerName: intl.formatMessage({ id: 'Estado' }),
            editable: false,
            flex: 120,
        },
    ];
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
        paletizado_Id: false,
    });
    return (
        <div>
            <Toolbar>
                <div className="d-flex justify-content-center" style={{ width: '100%' }}>
                    {/*<div className="col col-md-3"></div>*/}
                    <div className="col col-md-4 px-2">
                        <Card
                            className="my-2"
                            style={{
                                maxWidth: '18rem', textAlign: 'center', backgroundColor: '#25675D', color: 'white'
                            }}
                        >
                            <CardBody>
                                <div className="d-flex justify-content-around">
                                    <h1><FaPallet style={{ color: '#52877D' }} /></h1>
                                    <div>
                                        Pesos faltantes
                                        <CardTitle tag="h4">
                                            {pesosFaltantes}
                                        </CardTitle>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                    
                </div>
                <div class="d-flex flex-row-reverse w-100">
                    <div class="py-2 px-4">
                        <Button className="AddButton" style={{ whiteSpace: 'nowrap', marginTop: '25px' }}
                            onClick={() => {
                                props.setVariantes_onclick()
                            }}>
                            <CachedOutlinedIcon /> Actualizar
                        </Button>
                    </div>
                    <div class="py-2 px-4" style={{ textAlign: 'right' }}>
                        <Button className="DownloadButton" style={{ whiteSpace: 'nowrap' }}
                            onClick={() => {
                                if (pesosFaltantes == 0) {
                                    setShowError(false);
                                    props.downloadReport_onclick();
                                }
                                else {
                                    setShowError(true);
                                }
                            }}>
                            <DownloadOutlinedIcon fontSize='large' /> Descargar reporte de Variantes
                        </Button>
                        {pesosFaltantes > 0 && showError ?
                            <ErrorModal message="No es posible descargar el reporte. Debe completar los pesos faltantes en las paletas señaladas"></ErrorModal>:""
                        }
                        
                    </div>


                </div>

            </Toolbar>
            <Box sx={{
                height: 600, width: '100%',
            }}>

                <StripedDataGrid
                    rows={sortedRows}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20]}
                    pagination
                    disableRowSelectionOnClick
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                    }
                    getRowId={(row) => row[keyField]}
                    //sortModel={sortModel}
                    //onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500, placeholder: 'Buscar' },
                            printOptions: { disableToolbarButton: true },
                            csvOptions: { disableToolbarButton: false },
                        },
                    }}
                    componentsProps={{
                        pagination: {
                            labelRowsPerPage: intl.formatMessage({ id: 'Resultados por pagina' }),
                            labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} ${intl.formatMessage({ id: 'de' })} ${count}`,
                        }
                    }}

                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(newModel) =>
                        setColumnVisibilityModel(newModel)
                    }
                />
            </Box>
        </div>
    );
}
